export const userConstants = {
  LOGIN_REQUEST: "USERS_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USERS_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USERS_LOGIN_FAILURE",
  LOGOUT: "USERS_LOGOUT",
  UNDP_AUTH_REQUEST: "UNDP_AUTH_REQUEST",
  UNDP_NOT_AUTH: "UNDP_NOT_AUTH"
};
